import React from "react";
import RegisterForm from "../components/registerForm";

import { _ } from "libs";

export const RegisterBox = () => {
	return (
		<div className="box">
			<div className="boxLeader">
				<h2>{_("loginPage.heading")}</h2>
				<div className="illustration player1" />
			</div>
			<div className="boxContent">
				<RegisterForm />
			</div>
		</div>
	);
};
type BoxProps = {
	destination?: string;
};
export const SimpleRegisterBox = ({ destination }: BoxProps) => {
	return <RegisterForm destination={destination} />;
};

const Register = () => (
	<div className="boxWrap">
		<RegisterBox />
	</div>
);

export default Register;
